<template>
  <el-form :model="form" ref="form">
    <el-form-item
      :label="L10n('description')"
      prop="description"
      class="material-style"
    >
      <el-input
        type="textarea"
        :value="form.description"
        @input="form.description = valueTrimLeft($event)"
      />
    </el-form-item>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'FormNew',
  mixins: [Form]
}
</script>
